import AppHeader from '../AppHeader'
export default {
  name: 'will-must',
  components: {
    AppHeader
  },
  created () {
    this.search()
  },
  data () {
    return {
      searchCallbackFlag: false
    }
  },
  computed: {
    willMusts () {
      return this.$store.getters.willMusts
    }
  },
  methods: {
    search: function () {
      const self = this
      const callback = function () {
        self.searchCallbackFlag = true
      }
      const data = {
        'shop_id': window.localStorage.getItem('shop_id')
      }
      this.$store.dispatch('WILL_MUST_GET', {data: data, callback: callback})
    },
    formatDateToYM: function (str) {
      const re = /([0-9]*)-([0-9]*)-([0-9]*)/
      const result = str.replace(re, '$1年$2月')
      return result
    },
    printWillMust: function (data) {
      const params = {
        'shop_id': window.localStorage.getItem('shop_id'),
        'will_must_date': data['will_must_date']
      }
      this.$store.dispatch('WILL_MUST_DOWNLOAD', { data: params, callback: this.onGetPdf })
    },
    onGetPdf: function (data) {
      const link = document.getElementById('print_download_link')
      link.setAttribute('download', data.url)
      link.href = data.url
      link.target = '_blank'
      link.click()
      const self = this
      setTimeout(function () {
        // ファイル削除
        self.$store.dispatch('WILL_MUST_DELETE', {data: {download_id: data.download_id}, callback: (data) => {}})
      }, 1000)
    },
    getComfirmed: function (date) {
      let today = new Date()
      let wmday = new Date(date)
      return today > wmday ? '締切後' : '受付中'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/will-must.js